import React from 'react';
import Name from './name';
import Meaning from './meaning';
import Time from '../Time';

const Details = (props)=> {
    const { boxStyle, divStyle } = styles;
    return(
        <div style={boxStyle}>

             <div>
             <Name currentName={props.currentName}/>
             <Meaning currentName={props.currentName}/>
              <div style={divStyle}>
               <Time/>
              </div>
             </div>
        </div>
    )
}

const styles = {
    boxStyle:{
        marginLeft: "70px",
        marginTop: "10px",
        border: "1px solid #ccc",
        width: "72%",
        minHeight: "50px",
        padding: "10px",
        display: "flex",
        fontFamily: "Helvetica, arial, sans-serif",
        fontSize: "14px",
        lineHeight: "18px",
        borderRadius: "5px",
        backgroundColor: "white"
        },
    divStyle:{
        display: "flex",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "5px"
    }
}

export default Details;;


// WEBPACK FOOTER //
// ./src/components/mainpage/box/Details.js